import PropTypes from 'prop-types';
import * as S from './styles';

const getVisiblePages = (page, totalPages) => {
  const pages = [];

  for (let i = 1; i <= totalPages; i += 1) {
    const isEdge = i === 1 || i === totalPages;
    const isNearCurrent = Math.abs(i - page) <= 1;
    const isNearStart = page <= 2 && i <= 3;
    const isNearEnd = page >= totalPages - 1 && i >= totalPages - 2;

    if (isEdge || isNearCurrent || isNearStart || isNearEnd) {
      pages.push(i);
    }
  }

  return pages.reduce((items, value, index) => {
    const previous = pages[index - 1];

    if (previous && value - previous === 2) {
      items.push({ type: 'page', value: value - 1 });
    } else if (previous && value - previous > 2) {
      items.push({ type: 'ellipsis', key: `ellipsis-${value}` });
    }

    items.push({ type: 'page', value });

    return items;
  }, []);
};

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <S.Nav aria-label="Pagination">
      <S.ArrowButton
        type="button"
        aria-label="Previous page"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
      >
        ‹
      </S.ArrowButton>
      {getVisiblePages(page, totalPages).map((item) => (
        item.type === 'ellipsis'
          ? <S.Ellipsis key={item.key}>…</S.Ellipsis>
          : (
            <S.PageButton
              key={item.value}
              type="button"
              $active={item.value === page}
              onClick={() => onChange(item.value)}
            >
              {item.value}
            </S.PageButton>
          )
      ))}
      <S.ArrowButton
        type="button"
        aria-label="Next page"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
      >
        ›
      </S.ArrowButton>
    </S.Nav>
  );
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};
